module.exports = __webpack_public_path__ + "img/icon-2-4d81e6b0.svg";